
//column heads for Exception handling Request 
export const columns: TableColumn[] = [
    {
      Header: "tableCommon.sl_no",
      accessor: "slno",
    },
    {
      Header: "deviationIncident.tableColumns.deviationId",
      accessor: "deviationId",
    },
    {
      Header: "deviationIncident.tableColumns.areaCode",
      accessor: "area_code",
    },
    {
      Header: "deviationIncident.tableColumns.areaEquipment",
      accessor: "equipment_name",
    },
    {
      Header: "deviationIncident.tableColumns.activityProcess",
      accessor: "process",
    },
    // {
    //   Header: "plateInventory.tableColumns.quantity",
    //   accessor: "quantity",
    // },
    {
      Header: "deviationIncident.tableColumns.operatorName",
      accessor: "operator_name",
    },
    {
      Header: "deviationIncident.tableColumns.operatorId",
      accessor: "operator_id",
    },
    {
      Header: "deviationIncident.tableColumns.date",
      accessor: "date",
    },
    {
      Header: "deviationIncident.tableColumns.reason",
      accessor: "reason",
    },
    {
      Header: "exceptionHandling.tableColumns.status",
      accessor: "status",
    },
   
]


//column heads for Exception handling History  
export const columnsHistory: TableColumn[] = [
  {
    Header: "tableCommon.sl_no",
    accessor: "slno",
  },
  {
    Header: "deviationIncident.tableColumns.deviationId",
    accessor: "deviationId",
  },
  {
    Header: "deviationIncident.tableColumns.areaCode",
    accessor: "area_code",
  },
  {
    Header: "deviationIncident.tableColumns.areaEquipment",
    accessor: "equipment_name",
  },
  {
    Header: "deviationIncident.tableColumns.activityProcess",
    accessor: "process",
  },
  // {
  //   Header: "plateInventory.tableColumns.quantity",
  //   accessor: "quantity",
  // },
  {
    Header: "deviationIncident.tableColumns.operatorName",
    accessor: "operator_name",
  },
  {
    Header: "deviationIncident.tableColumns.operatorId",
    accessor: "operator_id",
  },
  {
    Header: "deviationIncident.tableColumns.date",
    accessor: "date",
  },
  {
    Header: "deviationIncident.tableColumns.reason",
    accessor: "reason",
  },
  {
    Header: "exceptionHandling.tableColumns.status",
    accessor: "status",
  },
]


interface TableColumn {
  Header: string;
  accessor: string;
}
